import { useRef } from "react";
import { ImagePlus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const L = ({ children }) => <Label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">{children}</Label>;

const Logo = ({ f, setF, disabled }) => {
  const ref = useRef(null);
  const onFile = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Seleziona un'immagine (PNG o JPG)");
    if (file.size > 500 * 1024) return toast.error("Il logo deve essere più piccolo di 500 KB");
    const reader = new FileReader();
    reader.onload = () => setF((s) => ({ ...s, logo: reader.result }));
    reader.readAsDataURL(file);
  };
  return (
    <div className="sm:col-span-2">
      <L>Logo</L>
      <div className="flex items-center gap-4">
        <div className="flex h-20 w-36 items-center justify-center rounded-md border border-dashed border-slate-300 bg-slate-50">
          {f.logo ? <img src={f.logo} alt="Logo" className="max-h-16 max-w-[8rem] object-contain" data-testid="intestazione-logo-preview" /> : <span className="text-xs text-slate-400">Nessun logo</span>}
        </div>
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid="intestazione-logo-input" />
        <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={() => ref.current.click()} data-testid="intestazione-logo-button"><ImagePlus className="mr-1 h-4 w-4" /> Carica</Button>
        {f.logo && <Button type="button" variant="ghost" size="sm" disabled={disabled} onClick={() => setF((s) => ({ ...s, logo: "" }))} data-testid="intestazione-logo-remove"><Trash2 className="h-4 w-4" /></Button>}
      </div>
    </div>
  );
};

const CAMPI = [
  ["titolo_scheda", "Titolo scheda di lavoro"],
  ["titolo_contratto", "Titolo contratto di noleggio"],
  ["titolo_privacy", "Titolo modulo privacy"],
  ["titolo_preventivo", "Titolo preventivo di riparazione"],
];
const TESTI = [
  ["intestazione_extra", "Righe aggiuntive intestazione (es. sito web, orari, IBAN)", 2],
  ["piede_scheda", "Nota a piè di pagina della scheda di lavoro", 2],
  ["piede_contratto", "Nota a piè di pagina del contratto di noleggio", 2],
  ["piede_preventivo", "Nota a piè di pagina del preventivo di riparazione", 2],
];

export const IntestazioniSettings = ({ f, setF, isAdmin, onSave }) => (
  <form onSubmit={onSave} className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="intestazioni-form">
    <h2 className="mb-1 font-heading text-base font-bold">Intestazioni documenti</h2>
    <p className="mb-4 text-xs text-slate-500">Logo, titoli e note stampati su scheda di lavoro, preventivo, contratto di noleggio e modulo privacy. Nome, indirizzo, telefono, email e P.IVA vengono dai Dati negozio.</p>
    <div className="grid gap-4 sm:grid-cols-2">
      <Logo f={f} setF={setF} disabled={!isAdmin} />
      {CAMPI.map(([k, label]) => (
        <div key={k}>
          <L>{label}</L>
          <Input disabled={!isAdmin} value={f[k] ?? ""} onChange={(e) => setF((s) => ({ ...s, [k]: e.target.value }))} data-testid={`intestazione-${k.replace(/_/g, "-")}-input`} />
        </div>
      ))}
      {TESTI.map(([k, label, rows]) => (
        <div key={k} className="sm:col-span-2">
          <L>{label}</L>
          <Textarea disabled={!isAdmin} rows={rows} value={f[k] ?? ""} onChange={(e) => setF((s) => ({ ...s, [k]: e.target.value }))} data-testid={`intestazione-${k.replace(/_/g, "-")}-input`} />
        </div>
      ))}
    </div>
    {isAdmin && <Button type="submit" className="mt-5 bg-orange-600 hover:bg-orange-700" data-testid="intestazioni-save-button">Salva intestazioni</Button>}
  </form>
);
